import React, { Component } from 'react'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithDataV3 } from '../../services/CABE';
import '../../css/dashboard.css'
import LoadingWindow from '../../components/LoadingWindow';
import { AiOutlineSearch, AiOutlineHistory, AiOutlineReload } from "react-icons/ai";
import { Menu } from "../../components/Menu/Menu";

const BTN_SECONDARY = { background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: '8px', color: '#0F172A', fontWeight: 600, padding: '0.4rem 0.9rem', fontSize: '0.8rem', cursor: 'pointer' }

function formatDateInput(date) {
    return date.toISOString().slice(0, 10)
}
function addDays(date, days) {
    const d = new Date(date)
    d.setDate(d.getDate() + days)
    return d
}

/**
 * TraceabilityV3 — listing report (2026-08-26, extends the 2026-08-18
 * single-document lookup this page started as). Client: "Rastrear cambios
 * y saber quien le mete mano y cuando" — for every Sales Order in a date
 * range (optionally text-filtered, works with or without search text),
 * shows who created it, who edited it after, and whether/when it became
 * an invoice.
 *
 * Grouped by SO folio, paginated by GROUP (an SO's own events never split
 * across pages) — same pattern as ProductPricing.js/PriceChangeReportV3.js.
 *
 * Two real gaps this surfaces (see documentAuditTrail.ts's class header for
 * the full story):
 *   - "Edited" events only started being logged correctly 2026-08-26 (a real
 *     bug — every past edit was mislabeled 'created', fixed going forward,
 *     can't be reclassified retroactively).
 *   - "Who converted this to an invoice" isn't tracked yet at all — Invoices
 *     V3 doesn't write its own event for that step yet (pending a decision
 *     with the other programmer). The invoice NUMBER and DATE still show,
 *     from MAS90's own data — just not a "by whom".
 */
export default class TraceabilityV3 extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        companies: [],
        idCompany: getValueCookie('CompanyId') || '',
        dateStart: formatDateInput(addDays(new Date(), -7)),
        dateEnd: formatDateInput(new Date()),
        search: '',
        sos: [],
        events: [],
        invoices: [],
        page: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        loaded: false,
        errorMessage: '',
    }

    componentDidMount() {
        this.fetchCompanies()
    }

    async fetchCompanies() {
        try {
            const resp = await getInformationWithDataV3('/v3/pricing/companies', {})
            if (resp && resp.status && resp.status.code === 1 && Array.isArray(resp.data)) {
                this.setState({ companies: resp.data })
            }
        } catch (error) {
            console.error('fetchCompanies failed:', error)
        }
    }

    onChangeField = (field, value) => {
        this.setState({ [field]: value })
    }

    async loadReport(page) {
        const { idCompany, dateStart, dateEnd, search, pageSize } = this.state
        if (!idCompany || !dateStart || !dateEnd) return
        const targetPage = page || 1
        this.setState({ loading: true, errorMessage: '', page: targetPage })
        this.ModalLoading.current.showState(true)
        try {
            const resp = await getInformationWithDataV3('/v3/audit/trail-list', {
                idCompany: Number(idCompany), dateStart, dateEnd, search: search || undefined, page: targetPage, pageSize,
            })
            if (!resp || !resp.status || resp.status.code !== 1) {
                this.setState({ loading: false, loaded: true, errorMessage: 'Could not load the report.' })
                return
            }
            const sos = (resp.data && Array.isArray(resp.data.sos)) ? resp.data.sos : []
            const events = (resp.data && Array.isArray(resp.data.events)) ? resp.data.events : []
            const invoices = (resp.data && Array.isArray(resp.data.invoices)) ? resp.data.invoices : []
            this.setState({ loading: false, loaded: true, sos, events, invoices, total: resp.total || sos.length })
        } catch (error) {
            console.error('TraceabilityV3 loadReport failed:', error)
            this.setState({ loading: false, loaded: true, errorMessage: 'Could not load the report — the server did not respond.' })
        } finally {
            this.ModalLoading.current.showState(false)
        }
    }

    actionBadge(action) {
        const styles = {
            created: { bg: 'rgba(37,99,235,0.08)', color: '#1e40af', label: 'Created' },
            edited: { bg: 'rgba(245,158,11,0.08)', color: '#92400E', label: 'Edited' },
            converted_to_invoice: { bg: 'rgba(16,185,129,0.08)', color: '#065F46', label: 'Converted to Invoice' },
        }
        const s = styles[action] || { bg: 'rgba(100,116,139,0.08)', color: '#334155', label: action }
        return (
            <span style={{
                background: s.bg, color: s.color, border: `1px solid ${s.color}33`,
                borderRadius: '999px', padding: '2px 10px', fontSize: '0.72rem', fontWeight: 700, whiteSpace: 'nowrap',
            }}>{s.label}</span>
        )
    }

    render() {
        const { companies, idCompany, dateStart, dateEnd, search, sos, events, invoices, page, pageSize, total, loading, loaded, errorMessage } = this.state
        const totalPages = Math.max(1, Math.ceil(total / pageSize))

        const eventsByOrder = {}
        for (const e of events) {
            // An SO's own events (docNo) AND any invoice event linked back to it (linkedSoNo) both belong under that SO.
            const key = e.docType === 'sales_order' ? e.docNo : e.linkedSoNo
            if (!key) continue
            if (!eventsByOrder[key]) eventsByOrder[key] = []
            eventsByOrder[key].push(e)
        }
        const invoiceByOrder = {}
        for (const inv of invoices) {
            invoiceByOrder[inv.SalesOrderNo] = inv
        }

        return (
            <div className="dash-page pb-5">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div style={{ marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiOutlineHistory style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Traceability (V3)</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Who created, edited, and invoiced each Sales Order</p>
                    </div>
                </div>

                <div className="container-fluid" style={{ marginTop: 24 }}>
                    {errorMessage && (
                        <div className="metric-card status-danger mb-3">
                            <div style={{ color: '#DC2626', fontSize: '0.85rem' }}>{errorMessage}</div>
                        </div>
                    )}

                    <div className="row g-3 mb-4 align-items-end">
                        <div className="col-auto">
                            <label style={{ display: 'block', fontSize: '0.78rem', color: '#64748B', marginBottom: '4px' }}>Company</label>
                            <select value={idCompany} onChange={(e) => this.onChangeField('idCompany', e.target.value)}
                                style={{ padding: '0.6rem 0.85rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9rem', minWidth: '200px' }}>
                                <option value="">Select a company...</option>
                                {companies.map((c) => (
                                    <option key={c.idCompany} value={c.idCompany}>{c.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-auto">
                            <label style={{ display: 'block', fontSize: '0.78rem', color: '#64748B', marginBottom: '4px' }}>From</label>
                            <input type="date" value={dateStart} onChange={(e) => this.onChangeField('dateStart', e.target.value)}
                                style={{ padding: '0.6rem 0.85rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9rem' }} />
                        </div>
                        <div className="col-auto">
                            <label style={{ display: 'block', fontSize: '0.78rem', color: '#64748B', marginBottom: '4px' }}>To</label>
                            <input type="date" value={dateEnd} onChange={(e) => this.onChangeField('dateEnd', e.target.value)}
                                style={{ padding: '0.6rem 0.85rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9rem' }} />
                        </div>
                        <div className="col-auto" style={{ flex: 1, minWidth: '220px' }}>
                            <label style={{ display: 'block', fontSize: '0.78rem', color: '#64748B', marginBottom: '4px' }}>Search (optional — SO No., customer, salesperson)</label>
                            <div style={{ position: 'relative' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: '12px', top: '13px', color: '#94A3B8' }} />
                                <input type="text" value={search} onChange={(e) => this.onChangeField('search', e.target.value)}
                                    onKeyDown={(e) => { if (e.key === 'Enter') this.loadReport(1) }}
                                    placeholder="Leave blank to list everything in range"
                                    style={{ padding: '0.6rem 0.85rem 0.6rem 2.1rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9rem', width: '100%' }} />
                            </div>
                        </div>
                        <div className="col-auto">
                            <button onClick={() => this.loadReport(1)} type="button" disabled={!idCompany}
                                style={{
                                    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                    border: 'none', borderRadius: '10px', color: 'white', padding: '0.7rem 1.5rem',
                                    fontWeight: 600, fontSize: '0.9rem', cursor: idCompany ? 'pointer' : 'default', opacity: idCompany ? 1 : 0.5,
                                    display: 'flex', alignItems: 'center', gap: '0.5rem',
                                }}>
                                <AiOutlineReload /> Load Data
                            </button>
                        </div>
                    </div>

                    {!loaded && !loading && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineSearch style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>Select a company and date range, then click <strong style={{ color: '#1e3a8a' }}>Load Data</strong>.</p>
                        </div>
                    )}

                    {loaded && sos.length === 0 && !loading && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineHistory style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>No Sales Orders found for this range.</p>
                        </div>
                    )}

                    {loaded && sos.length > 0 && (
                        <>
                            {sos.map((so) => {
                                const soEvents = eventsByOrder[so.order_no] || []
                                const invoice = invoiceByOrder[so.order_no]
                                const invoiceEvent = soEvents.find((e) => e.docType === 'invoice' && e.action === 'converted_to_invoice')
                                return (
                                    <div key={so.order_no} className="card mb-3" style={{ border: '1px solid #E2E8F0', borderRadius: '14px', overflow: 'hidden' }}>
                                        <div style={{ background: '#F1F5F9', padding: '10px 20px', display: 'flex', flexWrap: 'wrap', gap: '0.75rem', alignItems: 'center' }}>
                                            <span style={{ fontWeight: 800, fontSize: '0.9rem', color: '#0F172A' }}>#{so.order_no}</span>
                                            <span style={{ fontSize: '0.8rem', color: '#64748B' }}>{so.date ? new Date(so.date).toLocaleDateString() : ''}</span>
                                            <span style={{ fontSize: '0.8rem', color: '#64748B' }}>{so.customer_no} — {so.customer_name}</span>
                                            <span style={{ fontSize: '0.8rem', color: '#64748B' }}>Salesperson: {so.salesperson_no}</span>
                                            <span style={{ marginLeft: 'auto' }}>
                                                {invoice
                                                    ? <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#065F46' }}>→ Invoice {invoice.InvoiceNo} ({new Date(invoice.InvoiceDate).toLocaleDateString()})</span>
                                                    : <span style={{ fontSize: '0.78rem', color: '#94A3B8' }}>Not yet invoiced</span>}
                                            </span>
                                        </div>
                                        <div style={{ padding: soEvents.length ? '0.75rem 1.25rem' : '0' }}>
                                            {soEvents.length === 0 ? (
                                                <div style={{ padding: '0.75rem 1.25rem', fontSize: '0.8rem', color: '#94A3B8', fontStyle: 'italic' }}>
                                                    No tracked events for this order (saved before traceability tracking, or before the edit-tracking fix on 2026-08-26).
                                                </div>
                                            ) : soEvents.map((row, i) => (
                                                <div key={row.id || i} style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', padding: '4px 0' }}>
                                                    {this.actionBadge(row.action)}
                                                    <span style={{ fontSize: '0.82rem', color: '#334155' }}>By <strong>{row.performedBy}</strong></span>
                                                    {row.salespersonNo && <span style={{ fontSize: '0.78rem', color: '#94A3B8' }}>Salesperson {row.salespersonNo}</span>}
                                                    <span style={{ fontSize: '0.75rem', color: '#94A3B8', marginLeft: 'auto' }}>{row.performedAt ? new Date(row.performedAt).toLocaleString() : ''}</span>
                                                </div>
                                            ))}
                                            {/* Invoice linked but no 'converted_to_invoice' event yet — real gap,
                                                not a bug: Invoices V3 doesn't log who did this step yet (2026-08-26).
                                                Disappears automatically once it does. */}
                                            {invoice && !invoiceEvent && (
                                                <div style={{ padding: '4px 0', fontSize: '0.75rem', color: '#94A3B8', fontStyle: 'italic' }}>
                                                    Who generated this invoice isn't tracked yet.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}

                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '0.75rem', padding: '8px 4px' }}>
                                <span style={{ fontSize: '0.8rem', color: '#64748B' }}>Page {page} of {totalPages} ({total} Sales Orders)</span>
                                <button style={{ ...BTN_SECONDARY, opacity: page <= 1 ? 0.5 : 1 }}
                                    disabled={page <= 1} onClick={() => this.loadReport(page - 1)}>Previous</button>
                                <button style={{ ...BTN_SECONDARY, opacity: page >= totalPages ? 0.5 : 1 }}
                                    disabled={page >= totalPages} onClick={() => this.loadReport(page + 1)}>Next</button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}
